import { DECODED_HASHTAG_REGEX } from '../../../../constants';

export const findHashtags = (text: string | undefined) => {
  const hashtagsArr = text?.match(DECODED_HASHTAG_REGEX);

  if (!hashtagsArr) {
    return null;
  }

  return hashtagsArr.map((hashtag) => {
    if (hashtag) {
      return hashtag.toLowerCase();
    }

    return hashtag;
  });
};
